import { IEntity } from '../interfaces/entity';
import { Relationship } from './relationship';
import { Subject } from './subject';

export interface ISubjectLinkList{
  items: SubjectLink[];
  totalCount: number;
}

export class SubjectLink implements IEntity {
  id: number;
  uid: string;
  relationshipId: number;
  relationship: Relationship;
  subjectId: number;
  subject: Subject;
  linkedSubjectId: number;
  linkedSubject: Subject;
  linkType: number;
  dateCreated: string;
  createdById: number;
  primary: boolean;
  secondaryText: string;
  possibleRelationships: Relationship[];
  primaryLink: string;

  constructor(subjectLink?)
    {
        subjectLink = subjectLink || {};
        this.id = subjectLink.id;
        this.uid = subjectLink.uid;
        this.relationshipId = subjectLink.relationshipId;
        this.relationship = subjectLink.relationship;
        this.subjectId = subjectLink.subjectId;
        this.subject = subjectLink.subject;
        this.linkedSubjectId = subjectLink.linkedSubjectId;
        this.linkedSubject = subjectLink.linkedSubject;
        this.linkType = subjectLink.linkType;
        this.dateCreated = subjectLink.dateCreated;
        this.createdById = subjectLink.createdById;
        this.primary = subjectLink.primary || false;
        this.secondaryText = subjectLink.secondaryText;
        this.possibleRelationships = subjectLink.possibleRelationships || [];
        this.primaryLink = subjectLink.primaryLink;
    }
}
